import { LinksFunction } from '@remix-run/node';
import {
    Links,
    Meta,
    Outlet,
    Scripts,
    ScrollRestoration,
    useRouteError,
} from '@remix-run/react';
import { captureRemixErrorBoundaryError } from '@sentry/remix';
import { useEffect } from 'react';
import { themeChange } from 'theme-change';

import stylesheet from '~/tailwind.css?url';

export const links: LinksFunction = function () {
    return [
        { href: stylesheet, rel: 'stylesheet' },
        { href: '/favicon.png', rel: 'apple-touch-icon' },
        {
            href: '/favicon.png',
            rel: 'icon',
            type: 'image/png',
        },
        {
            href: '/favicon.ico',
            rel: 'icon',
            type: 'image/x-icon',
        },
    ];
};

/**
 *
 * @param root0
 * @param root0.children
 */
export function Layout({ children }: { children: React.ReactNode }) {
    useEffect(() => {
        themeChange(false);
    }, []);
    return (
        <html data-theme={'dark'} lang="en">
            <head>
                {/* FIXME this lowers Lighthouse score slightly due to needing to load theme-change, but it prevents flicker for now */}
                <script src="https://cdn.jsdelivr.net/npm/theme-change@2.0.2/index.js"></script>
                <meta charSet="utf-8" />
                <meta
                    content="width=device-width, initial-scale=1"
                    name="viewport"
                />
                <Meta />
                <Links />
            </head>
            <body>
                {children}
                <ScrollRestoration />
                <Scripts />
            </body>
        </html>
    );
}

export const ErrorBoundary = () => {
    const error = useRouteError();
    captureRemixErrorBoundaryError(error);
    return <div>Something went wrong</div>;
};

/**
 *
 */
export default function App() {
    return <Outlet />;
}
